import { OpenPanel } from "@openpanel/web";

// The phone-scan route's URL carries a short-lived auth token — never track it,
// or the token leaks into OpenPanel via screen-view tracking. Also re-checked
// per manual event in `~/lib/track` (the SPA changes path without a reload).
export const PROOF_ROUTE_PREFIX = "/laadpaal-locatie/";

export function onProofRoute(): boolean {
  return (
    typeof window !== "undefined" &&
    window.location.pathname.startsWith(PROOF_ROUTE_PREFIX)
  );
}

const isProofRoute = onProofRoute();

export const op = new OpenPanel({
  clientId: import.meta.env.VITE_OPENPANEL_CLIENT_ID,
  trackScreenViews: !isProofRoute,
  trackOutgoingLinks: !isProofRoute,
  trackAttributes: !isProofRoute,
});
